import React from "react";
import { Route, Redirect } from "react-router-dom";
const PublicRoute = ({ restricted, admin, user, component: Comp, ...rest }) => {
  const switchUser =(props)=>{
    if(admin){
      return user ? (<Redirect to="/admin/dashboard"/>):<Comp {...props} user={user} />
    }
    else{
    return  user ? (
    <Redirect to="/dashboard" />
    ) : (
    <Comp {...props} user={user} />
    )
    }
  }
  return (
    <Route
      {...rest}
      component={(props) =>
        restricted ? switchUser(props) : (
          <Comp {...props} user={user} />
        )
      }
    />
  );
};

export default PublicRoute;
